import React, { useContext, useState } from 'react';
import { FaCheckCircle } from "react-icons/fa";
import { MdAlternateEmail } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import { FaMapLocationDot } from "react-icons/fa6";
import 'animate.css';
import NavBar from './navbar/navbar';
import Footer from './footer/footer';
import { validateEmail } from '../Files/UseFunction';
import { BaseURL } from '../Files/BaseURL';
import AlertContext from '../Context/Alert/AlertContext';




export default function Contact() {
  const [formData, setFormData] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Company: '',
    Message: '',
  });
  const [isCheck, setisCheck] = useState(false)

  const [errors, setErrors] = useState({});

  const {showAlert}= useContext(AlertContext)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const { FirstName, LastName, Email, Company, Message } = formData;

    const newErrors = {};
    if (!FirstName) newErrors.FirstName = 'First name is required';
    if (!LastName) newErrors.LastName = 'Last name is required';
    if (!Email) {
      newErrors.Email = 'Email is required';
    } else if (!validateEmail(Email)) {
      newErrors.Email = 'Invalid email format';
    }
    if (!Company) newErrors.Company = 'Company is required';
    if (!Message) newErrors.Message = 'Message is required';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await fetch(`${BaseURL}/api/portfolio/sendMail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ FirstName, LastName, Email, Company, Message }),
      });

      const result = await response.json();
      if (result.success) {
        showAlert('Email sent successfully', "success");
        setFormData({ FirstName: '', LastName: '', Email: '', Company: '', Message: '' });
        setErrors({});
      } else {
        showAlert('Failed to send email','success');
      }
    } catch (error) {
      console.error('Error:', error);
      showAlert('An error occurred while sending the email','success');
    }
  };

  const myList = [
    'Payments and financial products in a single platform',
    'Transparent pay-as-you-go pricing',
    'Access to hundreds of payment methods'
  ];

  const listItems = myList.map((item, index) => (
    <li className='py-4 inline-flex flex-row' key={index}>
      <div style={{ width: '20px', marginRight: '10px', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
        <FaCheckCircle size={16} alignmentBaseline='baseline' />
      </div>
      <p style={{ margin: '0', flex: 1 }}>{item}</p>
    </li>
  ));

  return (
    <>
      <NavBar />
      <div className='w-full h-full flex flex-row gap-24 font-sans flex-wrap justify-center  animate__animated  animate__slideInDown'>
        <div className='bg-gray-100 w-full sm:w-2/5   '>
          <div className=' h-full mx-4 p-4 '>
            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="38" viewBox="0 0 41 38" aria-label="hands-love" role="img" className="icon ds-color-green ds-margin-bottom-24 fill-green-500" data-v-c9686970="" data-v-8361f0e6="" element-id="237">
              <path stroke="none" d="M36.2253 4.08351C33.7653 1.62351 30.5053 0.273513 27.0353 0.273513C24.5153 0.273513 22.1053 0.993513 20.0353 2.32351C14.8953 -0.976487 8.21527 -0.296488 3.83527 4.08351C-0.564733 8.48351 -1.22473 15.2335 2.14527 20.3735C1.62527 21.7935 1.91527 23.4535 3.05527 24.5935C3.80527 25.3535 4.81527 25.7635 5.88527 25.7635C5.97527 25.7635 6.06527 25.7435 6.15527 25.7335C6.08527 26.8435 6.45527 27.9835 7.29527 28.8335C8.07527 29.6135 9.09527 30.0035 10.1253 30.0035C10.2153 30.0035 10.3053 29.9835 10.3953 29.9735C10.3153 31.0835 10.6953 32.2235 11.5353 33.0735C12.2853 33.8335 13.2953 34.2435 14.3653 34.2435C14.7053 34.2435 15.0253 34.1835 15.3453 34.1035C15.4153 35.0135 15.7853 35.9035 16.4853 36.6035C17.2653 37.3835 18.2853 37.7735 19.3153 37.7735C20.3353 37.7735 21.3653 37.3835 22.1453 36.6035L24.2653 34.4835C24.5453 34.2035 24.7653 33.8735 24.9453 33.5335C24.9553 33.5335 24.9653 33.5335 24.9753 33.5335C26.0253 33.5335 27.0353 33.1235 27.7953 32.3635C28.6453 31.5135 29.0153 30.3735 28.9353 29.2635C29.0253 29.2735 29.1153 29.2935 29.2053 29.2935C30.2253 29.2935 31.2553 28.9035 32.0353 28.1235C32.7953 27.3735 33.2053 26.3635 33.2053 25.2935C33.2053 25.2035 33.1853 25.1135 33.1753 25.0235C33.2653 25.0335 33.3553 25.0535 33.4453 25.0535C34.5153 25.0535 35.5153 24.6335 36.2753 23.8835C37.0353 23.1235 37.4553 22.0935 37.4453 21.0335C41.3153 15.8835 40.8153 8.66351 36.2253 4.08351ZM4.47527 23.1735C3.69527 22.3935 3.69527 21.1235 4.47527 20.3435L6.59527 18.2235C6.98527 17.8335 7.49527 17.6435 8.00527 17.6435C8.51527 17.6435 9.02527 17.8335 9.41527 18.2235C10.1953 19.0035 10.1953 20.2735 9.41527 21.0535L7.29527 23.1735C6.55527 23.9235 5.23527 23.9235 4.47527 23.1735ZM8.72527 27.4135C7.94527 26.6335 7.94527 25.3635 8.72527 24.5835L10.8453 22.4635C11.2353 22.0735 11.7453 21.8835 12.2653 21.8835C12.7753 21.8835 13.2853 22.0835 13.6753 22.4635C14.0553 22.8435 14.2653 23.3435 14.2653 23.8735C14.2653 24.4035 14.0553 24.9135 13.6753 25.2835L11.5553 27.4035C10.7653 28.1935 9.49527 28.1935 8.72527 27.4135ZM12.9653 31.6535C12.1853 30.8735 12.1853 29.6035 12.9653 28.8235L15.0853 26.7035C15.4653 26.3235 15.9653 26.1135 16.4953 26.1135C17.0253 26.1135 17.5353 26.3235 17.9053 26.7035C18.6853 27.4835 18.6853 28.7535 17.9053 29.5335L16.4953 30.9435L15.7853 31.6535C15.0353 32.4135 13.7253 32.4135 12.9653 31.6535ZM20.7453 35.1935C19.9653 35.9735 18.6953 35.9735 17.9153 35.1935C17.5353 34.8135 17.3353 34.3135 17.3353 33.7835C17.3353 33.2535 17.5453 32.7435 17.9153 32.3735L19.3253 30.9635L20.0353 30.2535C20.4253 29.8635 20.9353 29.6735 21.4553 29.6735C21.9653 29.6735 22.4753 29.8735 22.8653 30.2535C23.2453 30.6335 23.4553 31.1335 23.4553 31.6635C23.4553 32.1935 23.2453 32.7035 22.8653 33.0735L20.7453 35.1935ZM34.8853 22.4635C34.1253 23.2235 32.8153 23.2235 32.0553 22.4635L29.9353 20.3435L25.6953 16.1035C25.3053 15.7135 24.6753 15.7135 24.2853 16.1035C23.8953 16.4935 23.8953 17.1235 24.2853 17.5135L28.5253 21.7535L30.6453 23.8735C31.0253 24.2535 31.2353 24.7535 31.2353 25.2835C31.2353 25.8135 31.0253 26.3235 30.6453 26.6935C29.8653 27.4735 28.5953 27.4735 27.8153 26.6935L25.6953 24.5735L21.4553 20.3335C21.0653 19.9435 20.4353 19.9435 20.0453 20.3335C19.6553 20.7235 19.6553 21.3535 20.0453 21.7435L24.2853 25.9835L26.4053 28.1035C27.1853 28.8835 27.1853 30.1535 26.4053 30.9335C26.1353 31.2035 25.7953 31.3735 25.4353 31.4535C25.3853 30.4535 24.9953 29.5235 24.2853 28.8035C23.2553 27.7735 21.7953 27.4335 20.4753 27.7735C20.4053 26.8635 20.0353 25.9635 19.3353 25.2735C18.5853 24.5135 17.5753 24.1035 16.5053 24.1035C16.4153 24.1035 16.3253 24.1235 16.2353 24.1335C16.2453 24.0435 16.2653 23.9535 16.2653 23.8635C16.2653 22.7935 15.8453 21.7935 15.0953 21.0335C14.2453 20.1835 13.1053 19.8135 11.9953 19.8935C12.0653 18.7835 11.6953 17.6435 10.8553 16.7935C9.29527 15.2335 6.75527 15.2335 5.19527 16.7935L3.41527 18.5735C1.03527 14.3335 1.72527 9.02351 5.25527 5.49351C8.78527 1.96351 14.0853 1.28351 18.3253 3.63351C18.1653 3.78351 17.9953 3.92351 17.8353 4.07351L12.2153 9.70351L11.5453 10.4435C11.1653 10.8235 10.9553 11.3235 10.9553 11.8535C10.9553 12.3935 11.1653 12.8935 11.5453 13.2735L12.2553 13.9835C13.7653 15.4935 16.4053 15.4935 17.9153 13.9835L22.1553 9.74351C22.9353 8.96351 24.2053 8.96351 24.9853 9.74351L34.8853 19.6435C35.2053 19.9635 35.4053 20.3735 35.4553 20.8135C35.4553 20.8235 35.4553 20.8335 35.4553 20.8435C35.4553 20.8735 35.4653 20.9135 35.4653 20.9435C35.4953 21.5035 35.2853 22.0635 34.8853 22.4635ZM36.6553 18.6235C36.5453 18.4835 36.4253 18.3435 36.3053 18.2235L26.4053 8.32351C25.6553 7.57351 24.6453 7.15351 23.5753 7.15351C22.5053 7.15351 21.5053 7.57351 20.7453 8.32351L16.5053 12.5635C15.7453 13.3135 14.4353 13.3135 13.6753 12.5635L13.0053 11.8235L13.6753 11.0735L19.2553 5.49351C21.3353 3.41351 24.0953 2.27351 27.0353 2.27351C29.9753 2.27351 32.7353 3.41351 34.8153 5.49351C38.3453 9.03351 39.0153 14.4135 36.6553 18.6235Z" element-id="236"></path>
            </svg>
            <div className='w-full sm:w-fit'>
              <h1 className='text-5xl font-bold mt-4 leading-normal '>Say hello to your new financial technology partner</h1>

              <p className='mt-4 leading-normal'>We help high-growth companies like Spotify, H&M, and eBay find new opportunities through financial technology. </p>
              <ul className='flex flex-col'>{listItems}</ul>



              <p className='mt-4 leading-normal'>We'd love to hear more about your business. Fill out this form, and we'll get back to you as soon as possible.</p>
              <br />
              <p>Would you like to connect with us as a referral partner? Then, please fill out the <a className='cursor-pointer underline'>partner contact form</a>.</p>
            </div>
          </div>
        </div>

        <div className='h-full w-full sm:w-2/5 p-8 '>
          {/* Actual Contact Form Here */}
          <form className='flex flex-col gap-8' onSubmit={handleSubmit}>
            <p className='text-3xl font-bold'>
              Achieve your ambitions faster
            </p>

            <label for="FirstName" className="relative block overflow-hidden rounded-md border border-gray-200 px-3 pt-3 shadow-sm focus-within:border-blue-600 focus-within:ring-1 focus-within:ring-blue-600">
              <input
                type="text"
                id="FirstName"
                name="FirstName"
                value={formData.FirstName}
                onChange={handleChange}
                required
                placeholder="First Name"
                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
              />
              <span className="absolute start-3 top-3 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-3 peer-focus:text-xs">First Name</span>
            </label>

            <label for="LastName" className="relative block overflow-hidden rounded-md border border-gray-200 px-3 pt-3 shadow-sm focus-within:border-blue-600 focus-within:ring-1 focus-within:ring-blue-600">
              <input
                type="text"
                placeholder="Last Name"
                id="LastName"
                name="LastName"
                required
                value={formData.LastName}
                onChange={handleChange}
                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
              />
              <span className="absolute start-3 top-3 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-3 peer-focus:text-xs">Last Name</span>
            </label>

            <label for="Company" className="relative block overflow-hidden rounded-md border border-gray-200 px-3 pt-3 shadow-sm focus-within:border-blue-600 focus-within:ring-1 focus-within:ring-blue-600">
              <input
                type="text"
                id="Company"
                name="Company"
                required
                value={formData.Company}
                onChange={handleChange}
                placeholder="Company"
                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
              />
              <span className="absolute start-3 top-3 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-3 peer-focus:text-xs">Company</span>
            </label>

            <label for="Email" className="relative block overflow-hidden rounded-md border border-gray-200 px-3 pt-3 shadow-sm focus-within:border-blue-600 focus-within:ring-1 focus-within:ring-blue-600">
              <input
                type="email"
                id="Email"
                name="Email"
                required
                value={formData.Email}
                onChange={handleChange}
                placeholder="Email Address"
                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
              />
              <span className="absolute start-3 top-3 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-3 peer-focus:text-xs">Email Address</span>
            </label>

            <label for="Message" className="relative block overflow-hidden rounded-md border border-gray-200 px-3 pt-3 shadow-sm focus-within:border-blue-600 focus-within:ring-1 focus-within:ring-blue-600">
              <textarea
                id="Message"
                name="Message"
                required
                value={formData.Message}
                onChange={handleChange}
                placeholder="Message"
                className="peer h-20 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
              ></textarea>
              <span className="absolute start-3 top-3 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-3 peer-focus:text-xs">Message</span>
            </label>


            <div className="flex">
              <div className="flex items-center h-5">
                <input
                  id="helper-checkbox"
                  aria-describedby="helper-checkbox-text"
                  type="checkbox"
                  onChange={() => {
                    if (isCheck) {
                      setisCheck(false)
                    } else {
                      setisCheck(true)
                    }
                  }}
                  required
                  checked={isCheck}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
              <div className="ms-2 text-sm">
                <label for="helper-checkbox" className="font-medium text-gray-900 dark:text-gray-300">I agree to the terms and conditions</label>
                <p id="helper-checkbox-text" className="text-xs font-normal text-gray-500 dark:text-gray-300">By checking this box I give my consent to Paycott using my personal information to send me communications regarding paycotts products, events, trainings, reports and services.</p>
              </div>
            </div>

            <button
              className="group text-left relative inline-block overflow-hidden border border-green-500 px-8 py-3 focus:outline-none focus:ring"
              type='submit'
            >
              <span
                className="absolute inset-y-0 left-0 w-[2px] bg-green-500 transition-all group-hover:w-full group-active:bg-green-500"
              ></span>

              <span
                className="relative text-sm font-medium text-green-500 transition-colors group-hover:text-white"
              >
                Send Enquiry
              </span>
            </button>














          </form>

        </div>





      </div>

      <div className='flex w-full  flex-row flex-wrap gap-x-4 py-2 justify-center my-2'>

        <div className='w-64 h-40'>
          <MdAlternateEmail className='w-10 h-10 fill-green-500' />
          <p className='text-xl font-bold  '>Email</p>
          <a href='mailto:contactform@paycott.de' className='mt-2 cursor-pointer'>contactform@paycott.de</a>
        </div >

        <div className='w-64 h-40'>
          <BiSupport className='w-10 h-10 fill-green-500' />
          <p className='text-xl font-bold'>Contact</p>
          <p className='mt-2'>Contact us at 123456789</p>
        </div>

        <div className='w-64 h-40'>
          <FaMapLocationDot className='w-10 h-10 fill-green-500' />
          <p className='text-xl font-bold'>Location</p>
          <p className='mt-2'>Empire State Building</p>

        </div>


      </div >
      <div className='flex items-center justify-center w-full '>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.617541157565!2d-73.98823932473486!3d40.74844047138812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2s!4v1711972660307!5m2!1sen!2s"
          width={800}
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <Footer />
    </>

  );
}
